import { useTranslation } from "react-i18next";
import SimulatedData from "./simulatedData";

const SimulatedOverviewTable = () => {
  const { t } = useTranslation();
  const { data, loading, error } = SimulatedData();

  const columns = [
    { Header: t("scenarios.simulated.columns.id"), accessor: "id", width: "6%" },
    { Header: t("scenarios.simulated.columns.name"), accessor: "name", width: "16%" },
    { Header: t("scenarios.simulated.columns.description"), accessor: "description", width: "24%" },
    { Header: t("scenarios.simulated.columns.kpi"), accessor: "kpi", width: "16%" },
    { Header: t("scenarios.simulated.columns.dayType"), accessor: "day_type", width: "10%" },
    { Header: t("scenarios.simulated.columns.typicalDay"), accessor: "typical_day", width: "8%" },
    { Header: t("scenarios.simulated.columns.noAction"), accessor: "no_action", width: "8%" },
    { Header: t("scenarios.simulated.columns.action"), accessor: "action", width: "8%" },
    { Header: "%", accessor: "percentage", width: "4%" },
  ];

  const rows = (data || []).map((item) => ({
    id: item.id ?? "-",
    name: item.name ?? "-",
    description: item.description ?? "-",
    kpi: item.kpi ?? "-",
    day_type: item.day_type ?? "-",
    typical_day: item.typical_day ?? "-",
    no_action: item.no_action ?? "-",
    action: item.action ?? "-",
    percentage: item.percentage ?? "-",
  }));

  return {
    tableData: { columns, rows },
    loading,
    error,
  };
};

export default SimulatedOverviewTable;
